module.exports = __webpack_public_path__ + "img/bg1.0822c03b.png";